<mat-form-field appearance="outline">
    <mat-label>{{ label }}</mat-label>
    <input matInput [id]="inputId" [(ngModel)]="value" [placeholder]="placeholder" [matTooltip]="tooltip"
        (keyup.enter)="onEnter()" />

    <button *ngIf="value" mat-icon-button matSuffix aria-label="Clear" (click)="clear()">
        <mat-icon>close</mat-icon>
    </button>
</mat-form-field>